import React from 'react';
import {Provider} from 'react-redux';

import './shared/styles/crema.less';
import {
  AppContextProvider,
  AppInfoView,
  AppLayout,
  AppLocaleProvider,
  AppThemeProvider,
  AuthRoutes,
  InfoViewContextProvider,
  AppReCaptcha,
  AppLoadingScreen,
} from './@ict';
import configureStore from './redux/store';
import {BrowserRouter} from 'react-router-dom';
import './@ict/services/index';
import JWTAuthProvider from './@ict/services/auth/jwt-auth/JWTAuthProvider';

const store = configureStore();

const App = () => {
  console.log = () => {};
  return (
    <AppReCaptcha>
      <AppContextProvider>
        <Provider store={store}>
          <AppLoadingScreen>
            <AppThemeProvider>
              <AppLocaleProvider>
                <AppInfoView />
                <BrowserRouter>
                  <JWTAuthProvider>
                    <InfoViewContextProvider>
                      <AuthRoutes>
                        <AppLayout />
                      </AuthRoutes>
                    </InfoViewContextProvider>
                  </JWTAuthProvider>
                </BrowserRouter>
              </AppLocaleProvider>
            </AppThemeProvider>
          </AppLoadingScreen>
        </Provider>
      </AppContextProvider>
    </AppReCaptcha>
  );
};

export default App;
